module.exports = __webpack_public_path__ + "img/all_confirmed.a7f954d1.svg";